export default __webpack_public_path__ + "static/media/voteSuccess.f0cd8503.png";